import SVG from "./svg" 

export default SVG;